import { IconErrorSmall } from '@components/icons/error-small';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

export type FormErrorProps = {
  text?: string;
  isBold?: boolean;
  id?: string;
  /**
   * Announce the error when it appears. For fields that can report without a submit —
   * a file field rejects a pick immediately — where a silent error is the difference
   * between knowing and not. `role="alert"` rather than an `aria-live` region because
   * this element mounts together with its text.
   */
  isAnnounced?: boolean;
};

export function FormError({ text, isBold, isAnnounced, id }: FormErrorProps) {
  if (!text) return null;

  return (
    <Stack orientation="horizontal" space={1} id={id} role={isAnnounced ? 'alert' : undefined}>
      {/* The margin is so the icon can be in the middle of the first line if it breaks into multiple lines */}
      <IconErrorSmall color="error" style={{ marginTop: '0.125rem' }} />
      <Text font={isBold ? 'semibold14' : 'regular14'} color="error" text={text} />
    </Stack>
  );
}
